import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  unitGroup: {
    display: "flex",
    border: `1px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius.sm,
    overflow: "hidden",
  },
  unitButton: {
    fontFamily: "inherit",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.bold,
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    border: "none",
    cursor: "pointer",
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[700],
    transition: `background-color ${designTokens.transition.base}, color ${designTokens.transition.base}`,
    whiteSpace: "nowrap",
    ":hover": {
      backgroundColor: designTokens.neutral[100],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
      zIndex: "1",
    },
  },
  unitButtonDivider: {
    borderRight: `1px solid ${designTokens.neutral[300]}`,
  },
  unitButtonActive: {
    backgroundColor: designTokens.primary[900],
    color: designTokens.neutral.white,
    ":hover": {
      backgroundColor: designTokens.primary[900],
    },
  },
});
